<template>
  <div>
    <a-select v-model="selected" :not-found-content="loading ? undefined : null" :placeholder="placeholder" :mode="mode" :label-in-value="labelInValue" :allow-clear="allowClear" :disabled="disabled" :filter-option="false" @search="onSearch">
      <a-spin v-if="loading" slot="notFoundContent" size="small" />
      <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    mode: {
      type: String,
      default: 'default'
    },
    value: {
      type: [Array, Number, String],
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    role: {
      type: [String, Number],
      default: null
    },
    projectId: {
      type: [String, Number],
      default: 0
    },
    method: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelInValue: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      keywords: null
    };
  },
  computed: {
    selected: {
      get() {
        if (this.value) {
          return this.value;
        }
        return ['multiple', 'tags'].includes(this.mode) ? [] : null;
      },
      set(val) {
        this.$emit('change', val);
      }
    },
    userData() {
      return this.$store.getters.filterUser(this.projectId, this.keywords, 10);
    }
  },
  created() {
    if (Array.isArray(this.value) && this.value.length > 0) {
      this.selected = this.value;
    }
    this.utils.getUserData(this.projectId);
  },
  methods: {
    onSearch(value) {
      this.keywords = value;
    }
  }
};
</script>
